import React from "react";
import Home from "./components/Home/home";
import Navbar from "./components/Navbar/navbar";
import Footer from "./components/Footer/footer";
import About from "./components/About/about";
import Service from "./components/Service/service";
import Artists from "./components/Artists/artists";
import Blog from "./components/Blog/blogs";
import Contact from "./components/Contact/contact";
import Booking from "./components/Booking/booking";
// Blogs
import Blog1 from "./components/Blog/1";
import Blog2 from "./components/Blog/2";
import Blog3 from "./components/Blog/3";
import Blog4 from "./components/Blog/4";
import Blog5 from "./components/Blog/5";
import Blog6 from "./components/Blog/6";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

export default function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/artists" element={<Artists />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/1" element={<Blog1 />} />
        <Route path="/blog/2" element={<Blog2 />} />
        <Route path="/blog/3" element={<Blog3 />} />
        <Route path="/blog/4" element={<Blog4 />} />
        <Route path="/blog/5" element={<Blog5 />} />
        <Route path="/blog/6" element={<Blog6 />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
      <Footer />
    </Router>
  );
}
